import React, { useEffect ,useState} from 'react'
import { useParams , useNavigate } from 'react-router-dom';
import { FormLabel, TextField ,Box, Button, FormControlLabel, Checkbox } from '@mui/material';
import axios from 'axios';

function BookDetail() {
    const navigate = useNavigate();
    const [inputs, setInputs] = useState();
  const [name , setName] = useState('');
  const [author , setAuthor] = useState('');
  const [description , setDescription] = useState('');
  const [image , setImage] = useState('');
  const [price , setPrice] = useState('');
  const [checked, setChecked] = useState(false);
    const id = useParams().id;
    useEffect(() => {
        const fetchHandler = async () => {
            await axios.get(`https://bookstore-hyob.onrender.com/books/${id}`).then(res => res.data);
        }
        fetchHandler().then((data) => console.log(data.book));

    },[id]);

    const sendRequest = async () => {
        await axios.put(`http://localhost:5000/books/${id}`, {
          name: String(name),
          author: String(author),
          description: String(description),
          price: Number(price),
          image: String(image),
          available: Boolean(checked)
        }).then(res =>res.data);
      }

    const handleSubmit = (e) => {
        e.preventDefault();
        sendRequest().then(() => navigate('/book'));
    }
  return (
    <div>
      <form onSubmit={handleSubmit}>
       <Box display="flex" flexDirection="column" justifyContent={"centre"} maxWidth={700} alignContent={'center'} alignSelf='center' marginLeft='auto' marginRight='auto' marginTop={10}>
       <FormLabel>Name</FormLabel>
        <TextField onChange={(e) => setName(e.target.value)} margin='normal' fullWidth variant='outlined' name='name' />
        <FormLabel>Author</FormLabel>
        <TextField onChange={(e) => setAuthor(e.target.value)} margin='normal' fullWidth variant='outlined' name='author' />
        <FormLabel>Description</FormLabel>
        <TextField onChange={(e) => setDescription(e.target.value)} margin='normal' fullWidth variant='outlined' name='description' />
        <FormLabel>Image</FormLabel>
        <TextField onChange={(e) => setImage(e.target.value)} margin='normal' fullWidth variant='outlined' name='image' /> 
        <FormLabel>Price</FormLabel>
        <TextField onChange={(e) => setPrice(e.target.value)} type='number' margin='normal' fullWidth variant='outlined' name='price' />
        <FormControlLabel control={<Checkbox checked={checked} onChange={() => setChecked(!checked)} />} label="Available" />
        <Button variant='contained' sx={{mt: "20px"}} type='submit'>Update Book</Button>
       </Box>
      </form>
    </div>
  )
}

export default BookDetail
